import Vue from "vue";
import store from "../store";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
dayjs.extend(utc);
dayjs.extend(LocalizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(relativeTime);
Vue.filter("formatDate", (value:any, filterFormat?:string, tz: string = "") => {
  // @ts-ignore
  const { zone, format } = store.state.app.time;

  if (value) {
    let result = dayjs(value);
    if (tz) {
      result = result.tz(tz, false);
    }
    return result.format(filterFormat || format || "YYYY-MM-DD HH:mm:ss");
  }

  return "-";
});
